import { gql } from '@apollo/client';

export const LIST_BILL_ATTACHMENTS = gql`
  query ListBillAttachments($billId: ID!) {
    listBillAttachments(billId: $billId) {
      id
      billId
      fileName
      fileSize
      contentType
      uploaderId
      uploaderName
      createdAt
      canDelete
    }
  }
`;

export const GET_BILL_ATTACHMENT_DOWNLOAD_URL = gql`
  query GetBillAttachmentDownloadUrl($attachmentId: ID!) {
    getBillAttachmentDownloadUrl(attachmentId: $attachmentId)
  }
`;
